import { __exports as comparativePriceFilter } from './_virtual-comparativePriceFilter.js';
import { __require as requireContainer } from './vp-js-token-engine-build-infrastructure-container.js';
import { __require as requireVatHelper } from './vp-js-token-engine-build-common-vatHelper.js';
import { __require as requireLogger } from './vp-js-token-engine-build-infrastructure-logger.js';
import { __require as requireLocalizations } from './vp-js-token-engine-build-infrastructure-localizations.js';

var hasRequiredComparativePriceFilter;

function requireComparativePriceFilter () {
	if (hasRequiredComparativePriceFilter) return comparativePriceFilter;
	hasRequiredComparativePriceFilter = 1;

	Object.defineProperty(comparativePriceFilter, "__esModule", {
	  value: true
	});
	comparativePriceFilter.ComparativeDisplayType = void 0;
	comparativePriceFilter.comparativePriceFilter = comparativePriceFilter$1;
	comparativePriceFilter.isPriceDiscounted = isPriceDiscounted;
	comparativePriceFilter.shouldShowComparative = shouldShowComparative;
	var _container = requireContainer();
	var _vatHelper = requireVatHelper();
	var _logger = requireLogger();
	var _localizations = requireLocalizations();
	const LIST_PRICE_TEMPLATE = "<span class='swan-list-price'>{{listPrice}}</span>";
	const COMPARATIVE_LIST_PRICE_TEMPLATE = "<span class='swan-pricing-comparison'><span class='swan-list-price'><span class='swan-visually-hidden'>{{originalPrice}}</span>{{listPrice}}</span> <span class='swan-discount-price'><span class='swan-visually-hidden'>{{salePrice}}</span>{{discountPrice}}</span></span>";
	let ComparativeDisplayType = comparativePriceFilter.ComparativeDisplayType = /*#__PURE__*/function (ComparativeDisplayType) {
	  ComparativeDisplayType["Always"] = "Always";
	  ComparativeDisplayType["Never"] = "Never";
	  ComparativeDisplayType["Legacy"] = "Legacy";
	  ComparativeDisplayType["CustomerFriendly"] = "CustomerFriendly";
	  return ComparativeDisplayType;
	}({});
	function shouldShowComparative(listPrice, discountPrice, comparativeDisplayType) {
	  switch (comparativeDisplayType) {
	    case ComparativeDisplayType.Always:
	      return true;
	    case ComparativeDisplayType.Never:
	      return false;
	    case ComparativeDisplayType.Legacy:
	      _logger.logger.info('Incorrect Comparative Display Type, showing comparison');
	    case ComparativeDisplayType.CustomerFriendly:
	      return listPrice !== discountPrice && listPrice > 0 && discountPrice >= 0 && discountPrice < listPrice;
	  }
	}
	function isPriceDiscounted(listPrice, discountPrice) {
	  return listPrice !== discountPrice && listPrice > 0 && discountPrice >= 0 && discountPrice < listPrice;
	}
	async function comparativePriceFilter$1(culture, listPrice, discountPrice, currency, minimumFractionDigits, vatInc, hideVatMessage, hideShippingMessageInVatMessage, scope) {
	  const htmlTemplates = {};
	  const mustacheVariables = {};
	  let formattedDiscountedPrice;
	  if (listPrice !== discountPrice) {
	    htmlTemplates['comparativePriceListDiscount'] = COMPARATIVE_LIST_PRICE_TEMPLATE;
	    formattedDiscountedPrice = _container.formatterService.formatPrice({
	      culture,
	      currency,
	      price: discountPrice,
	      minimumFractionDigits
	    });
	    mustacheVariables['originalPrice'] = (0, _localizations.localized)('originalPrice', culture);
	    mustacheVariables['salePrice'] = (0, _localizations.localized)('salePrice', culture);
	  } else {
	    htmlTemplates['comparativePriceListDiscount'] = LIST_PRICE_TEMPLATE;
	  }
	  const formattedListPrice = _container.formatterService.formatPrice({
	    culture,
	    currency,
	    price: listPrice,
	    minimumFractionDigits
	  });
	  mustacheVariables['discountPrice'] = formattedDiscountedPrice;
	  mustacheVariables['listPrice'] = formattedListPrice;
	  mustacheVariables['vatInc'] = vatInc;
	  if (!hideVatMessage) {
	    mustacheVariables['vatMessage'] = await (0, _vatHelper.getVatHtml)(vatInc, culture, hideShippingMessageInVatMessage, scope);
	  }
	  return {
	    htmlTemplates,
	    mustacheVariables
	  };
	}
	
	return comparativePriceFilter;
}

export { requireComparativePriceFilter as __require };
//# sourceMappingURL=vp-js-token-engine-build-common-filters-comparativePriceFilter.js.map
